<template>
    <div class="comSelect" @click.stop="clickSelect">
        <input :value="selected.name" readonly :style="selectedBorder" />
        <i class="iconfont icon-xia" :style="{ color: showOptions ? '#FF8914' : '' }" />
        <div class="options" v-if="showOptions">
            <div
                v-for="item in options"
                :key="item.name"
                :class="[selected.name == item.name ? 'active' : '', item.disabled ? 'disabled' : '']"
                @click.stop="clickOption(item)"
            >
                {{ item.disabled ? "-" + item.name + "-" : item.name }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        options: Array,
        choosed: [Number, String],
    },
    data() {
        return {
            showOptions: false,
            selected: this.options[0],
        };
    },
    computed: {
        selectedBorder() {
            return {
                // border: this.showOptions?'1px solid #FF8914' : ""
            };
        },
    },
    methods: {
        clickSelect() {
            this.showOptions = !this.showOptions;
        },
        clickOption(item) {
            if (item.disabled) {
                return;
            } else {
                this.showOptions = !this.showOptions;
                this.selected = item;
                this.$emit("clickOption", item);
            }
        },
        closeSelect() {
            this.showOptions = false;
        },
    },
    mounted() {
        window.addEventListener("click", this.closeSelect);
        if (this.choosed !== "") {
            this.options.forEach((item) => {
                if (item.value == this.choosed) {
                    this.selected = item;
                }
            });
        }
    },
    destroyed() {
        window.removeEventListener("click", this.closeSelect);
    },
};
</script>
<style lang="scss" scoped>
.comSelect {
    position: relative;
    user-select: none;
    input {
        padding: 3px 20px 4px;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        cursor: pointer;
        outline-color: #ff8914;
        user-select: none;
        font-size: inherit;
        color: inherit;
        background: inherit;
        border: 1px solid #bbb;
    }
    .icon-xia {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-40%);
        // font-size: inherit;
        font-size: 12px;
        color: #666;
    }
}
.options {
    position: absolute;
    top: 105%;
    left: 0;
    right: 0;
    z-index: 10;
    background: #fff;
    border: 1px solid #bbb;
    max-height: 250px;
    overflow: auto;
    div {
        width: 100%;
        box-sizing: border-box;
        padding-left: 20px;
        text-align: left;
        line-height: 35px;
        &:hover {
            cursor: pointer;
            color: #ff8914;
        }
        &.active {
            background: #ff8914;
            color: #fff;
        }
        &.disabled {
            background: #eee;
            color: #666;
            cursor: not-allowed;
        }
    }
    &::-webkit-scrollbar {
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 20px;
    }
}
</style>
